import z from "zod";
import { authedEndpoint } from "../../builder";

export const post = authedEndpoint.mutation(
    (data) => ({
        json: data,
        method: "post",
        url: "remote-storages",
    }),
    {
        input: z.object({
            name: z.string(),
            config: z.object({
                host: z.string(),
                password: z.string(),
                root: z.string().optional(),
                username: z.string(),
            }),
        }),
    },
);
